export default {
  Title: 'Προφίλ',

  PersonalInfo: {
    Title: 'Προσωπικές πληροφορίες'
  },
  Addresses: {
    Title      : 'Διευθύνσεις',
    Default    : 'Προεπιλεγμένη',
    Floor      : 'Όροφος',
    DoorBell   : 'Κουδούνι',
    Comment    : 'Οδηγίες',
    UseCustom  : 'Δεν βρίσκεις την διεύθυνση σου στο χάρτη;',
    NoAddresses: {
      Title   : 'Δεν έχετε προσθέσει ακόμη διευθύνσεις',
      Subtitle: 'Προσθέστε μια νέα διεύθυνση τώρα'
    },
    Notification: {
      Delete: {
        Title: 'Διαγραφή Διεύθυνσης;',
        Body : 'Είστε σίγουροι ότι θέλετε να διαγράψετε την διεύθυνση;'
      }
    },
    Field: {
      Nickname: {
        Label      : 'Φιλική Ονομασία',
        Hint       : '',
        Placeholder: 'Φιλική Ονομασία'
      },

      City: {
        Label      : 'Περιοχή',
        Hint       : '',
        Placeholder: 'Περιοχή'
      },

      Postcode: {
        Label      : 'Τ.Κ.',
        Hint       : '',
        Placeholder: 'Τ.Κ.'
      },

      Street: {
        Label      : 'Οδός',
        Hint       : '',
        Placeholder: 'Οδός'
      },

      Number: {
        Label      : 'Αριθμός',
        Hint       : '',
        Placeholder: 'Αριθμός'
      },

      Floor: {
        Label      : 'Όροφος',
        Hint       : '',
        Placeholder: 'Όροφος'
      },

      DoorBell: {
        Label      : 'Κουδούνι',
        Hint       : '',
        Placeholder: 'Κουδούνι'
      },

      Comment: {
        Label      : 'Οδηγίες διεύθυνσης',
        Hint       : '',
        Placeholder: 'Οδηγίες διεύθυνσης'
      },

      IsDefault: {
        Label      : 'Προεπιλεγμένη Διεύθυνση',
        Hint       : '',
        Placeholder: 'Προεπιλεγμένη Διεύθυνση'
      }
    },
    Button: {
      Add: {
        Title: 'Προσθήκη Διεύθυνσης',
        Icon : 'mdi-plus'
      },
      Change: {
        Title: 'Αλλαγή Διεύθυνσης',
        Icon : 'mdi-map-marker'
      },
      Select: {
        Title: 'Επιλογή Διεύθυνσης',
        Icon : 'mdi-map-marker'
      }
    }
  },
  OrderHistory: {
    Title   : 'Ιστορικό παραγγελιών',
    NoOrders: {
      Title   : 'Δεν έχετε κάνει ακόμη παραγγελίες',
      Subtitle: 'Θα βρείτε όλες τις λεπτομέρειες των παραγγελιών σας εδώ'
    }
  },
  Settings: {
    Title: 'Ρυθμίσεις',

    Profile     : 'Προφίλ',
    ChangePass  : 'Αλλαγή Κωδικού',
    Notification: {
      Marketing: 'Ενημερώσεις Marketing',
      System   : 'Ειδοποιήσεις Συστήματος',
      Delete   : {
        Title     : 'Αποστολή PIN',
        Subtitle  : 'Αποστολή PIN Επιβεβαίωσης',
        Body      : 'Θα λάβετε PIN στο email σας για να επιβεβαιώσετε την οριστική διαγραφή του λογαριασμού σας.',
        ConfirmPin: {
          Title   : 'Εισαγωγή PIN',
          Subtitle: 'Εισαγωγή PIN Επιβεβαίωσης',
          Body    : 'Η αποστολή του PIN επιβεβαίωσης έγινε επιτυχώς! Παρακαλούμε ελέγξτε το email σας. <br><br> Εισάγετε το PIN που λάβετε στο email σας για να επιβεβαιώσετε την οριστική διαγραφή του λογαριασμού σας.'
        }
      },
      Export: {
        Title     : 'Αποστολή PIN',
        Subtitle  : 'Αποστολή PIN Επιβεβαίωσης',
        Body      : 'Θα λάβετε PIN στο email σας για να επιβεβαιώσετε την εξαγωγή δεδομένων του λογαριασμού σας.',
        ConfirmPin: {
          Title   : 'Εισαγωγή PIN',
          Subtitle: 'Εισαγωγή PIN Επιβεβαίωσης',
          Body    : 'Η αποστολή του PIN επιβεβαίωσης έγινε επιτυχώς! Παρακαλούμε ελέγξτε το email σας. <br><br> Εισάγετε το PIN που λάβετε στο email σας για να επιβεβαιώσετε την εξαγωγή δεδομένων του λογαριασμού σας.'
        }
      }
    },
    Account      : 'Λογαριασμός',
    DeleteAccount: 'Οριστική Διαγραφή Λογαριασμού',
    ExportAccount: 'Εξαγωγή Προσωπικών Δεδομένων',

    Field: {
      Firstname: {
        Label      : 'Όνομα',
        Placeholder: 'Όνομα',
        Hint       : ''
      },
      Lastname: {
        Label      : 'Επώνυμο',
        Placeholder: 'Επώνυμο',
        Hint       : ''
      },
      Email: {
        Label      : 'Email',
        Placeholder: 'Email',
        Hint       : ''
      },
      Phone: {
        Label       : 'Κινητό',
        Placeholder : 'Κινητό',
        Hint        : '',
        NotValidated: 'Το κινητό τηλέφωνο δεν έχει επιβεβαιωθεί.'
      },
      Password: {
        Label      : 'Κωδικός',
        Placeholder: 'Κωδικός',
        Hint       : ''
      },
      NewPass: {
        Label      : 'Νέος Κωδικός',
        Placeholder: 'Νέος Κωδικός',
        Hint       : ''
      },
      NewPassConfirm: {
        Label      : 'Επιβεβαίωση Κωδικού',
        Placeholder: 'Επιβεβαίωση Κωδικού',
        Hint       : ''
      },
      Newsletter: {
        Label      : 'Newsletter',
        Placeholder: 'Newsletter',
        Hint       : ''
      },
      Push: {
        Label          : 'Push Notifications',
        Placeholder    : 'Push Notifications',
        PermissionError: 'Πρέπει πρώτα να επιτρέψετε τα push notifications στον browser',
        Hint           : ''
      },
      Sms: {
        Label      : 'SMS',
        Placeholder: 'SMS',
        Hint       : ''
      }
    }
  }
}
